module.exports = __webpack_public_path__ + "media/icons/check-545daea8.png";